var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/belgium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/belgium",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "belgium",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.043,15.923 C317.31,5.633 287.314,0 256,0 C224.686,0 194.69,5.633 166.957,15.923 L144.696,256 L166.957,496.077 C194.69,506.368 224.686,512 256,512 C287.314,512 317.31,506.368 345.043,496.077 L367.304,256 L345.043,15.923 Z",
    id: "Path",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,256 C512,145.93 442.528,52.094 345.043,15.924 L345.043,496.079 C442.528,459.906 512,366.072 512,256 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,256 C0,366.072 69.472,459.906 166.957,496.078 L166.957,15.924 C69.472,52.094 0,145.93 0,256 Z",
    id: "Path",
    fill: "#000000"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBe);
export default __webpack_public_path__ + "static/media/BE.91a45cbb7ea9d63c28af3a4daa076114.svg";
export { ForwardRef as ReactComponent };